/**
 * User Roles Enum
 * Centralized definition of all user roles in the system
 * Using slug-based identifiers instead of numeric IDs
 */
export const UserRole = {
  ADMIN: 'admin',
  CL: 'category-leader',
  CS: 'category-specialist',
  MANAGEMENT: 'manajemen',
  DIC: 'dic',
  USER: 'user',
  VENDOR: 'vendor',
}
